import Icon, { IconName } from "@repo/ui/components/ui/icon/icon";
import { cn } from "@repo/ui/lib/utils";

const GradientButton = ({
  icon,
  animation = false,
}: {
  icon: IconName;
  animation?: boolean;
}) => (
  <div className="relative">
    <svg
      viewBox="0 0 166 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn({ "animate-pulse-light": animation })}
    >
      <g opacity="0.3" filter="url(#filter0_f_1333_782)">
        <circle
          cx="83"
          cy="83"
          r="75"
          className="fill-[#DC196E] dark:fill-[#F8F6F7]"
        />
      </g>
      <g opacity="0.3" filter="url(#filter1_f_1333_782)">
        <circle
          cx="83"
          cy="83"
          r="55"
          className="fill-[#DC196E] dark:fill-[#F8F6F7]"
        />
      </g>
      <g opacity="0.3">
        <circle
          cx="83"
          cy="83"
          r="40"
          className="fill-[#DC196E] dark:fill-[#F8F6F7]"
        />
      </g>
      <circle cx="83" cy="83" r="30" fill="white" />
      <defs>
        <filter
          id="filter0_f_1333_782"
          x="0"
          y="-3"
          width="166"
          height="166"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_1333_782"
          />
        </filter>
        <filter
          id="filter1_f_1333_782"
          x="24"
          y="21"
          width="118"
          height="118"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_1333_782"
          />
        </filter>
        <filter
          id="filter2_f_1333_782"
          x="42"
          y="39"
          width="82"
          height="82"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            result="effect1_foregroundBlur_1333_782"
          />
        </filter>
      </defs>
    </svg>

    <Icon
      icon={icon}
      className="animate-none absolute top-[50%] ml-[1px] translate-y-[-50%] left-[50%] translate-x-[-50%] *:fill-primary-magenta stroke-primary-magenta h-[70px] w-[70px] max-md:h-[50px] max-md:w-[50px] p-4"
    />
  </div>
);

export default GradientButton;
